import React, { useState } from 'react'

import {
  Box,
  Button,
  CollapsableCard,
  Icon,
  Text,
  Touchable,
} from '@factorialco/deprecated-design-system'
import {
  AtsFillEvaluationFormFragment,
  EvaluationFormListItemFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { DisplayEvaluationForm } from './DisplayEvaluationForm'
import { FillEvaluationForm } from './FillEvaluationForm'

interface Props {
  evaluationForm: EvaluationFormListItemFragment
  application: AtsFillEvaluationFormFragment
}

export const EvaluationFormItem = ({ evaluationForm, application }: Props) => {
  const [showFillEvaluation, setShowFillEvaluation] = useState(false)
  const [showDisplayEvaluation, setShowDisplayEvaluation] = useState(false)

  const onClickFillEvaluation = () => {
    if (showDisplayEvaluation) setShowDisplayEvaluation(false)

    setShowFillEvaluation(true)
  }

  return (
    <CollapsableCard
      contentPadding="s16"
      contentBackground="grey200"
      open={showFillEvaluation || showDisplayEvaluation}
      Content={
        <>
          {showFillEvaluation && (
            <FillEvaluationForm
              application={application}
              evaluationForm={evaluationForm}
              onSubmitFillEvaluationForm={() => setShowFillEvaluation(false)}
            />
          )}
          {showDisplayEvaluation && <DisplayEvaluationForm evaluationForm={evaluationForm} />}
        </>
      }
      Card={
        <Box width="full" flexDirection="row" justifyContent="spaceBetween">
          <Box justifyContent="flexStart" alignItems="center" flexDirection="row" gap="s6">
            <Icon.Medium color="grey800" icon="star" />
            <Text.Normal weight="medium">{evaluationForm.name}</Text.Normal>
          </Box>
          {!showFillEvaluation && (
            <Box justifyContent="flexEnd" alignItems="center" flexDirection="row" gap="s24">
              <Touchable onClick={() => onClickFillEvaluation()}>
                <Button.Decorative>
                  {i18n.t('ats.application_details.evaluations.fill')}
                </Button.Decorative>
              </Touchable>
              <Touchable onClick={() => setShowDisplayEvaluation(!showDisplayEvaluation)}>
                <Icon.Small icon={showDisplayEvaluation ? 'chevron-up' : 'chevron-down'} />
              </Touchable>
            </Box>
          )}
        </Box>
      }
    />
  )
}
